export
    default {

        white:
            '#ffffff',

        black:
            '#000000',

        red_2:
            '#dc2b2b',

        red_3:
            '#ff5a65',

        pink_2:
            '#ffbec2',

        green_1:
            '#05c168',

        green_2:
            '#7fdca4',

        green_3:
            '#11845b',

        blue_1:
            '#141C64',

        blue_2:
            '#1631A1',

        blue_3:
            '#1B51FE',

        teal_1:
            '#7d42fb',

        teal_3:
            '#3324d5',

        orange:
            '#FFA800',

        gray_2:
            '#D5D5D5',

        gray_4:
            '#929292',

        gray_5:
            '#17181C',

        gray_6:
            '#F1F3F8',

        gray_7:
            '#c7c7cc',

        gray_8:
            '#e6e6e6',

        gray_9:
            '#D7D7D7',

        gray_10:
            '#CED5DD',

        gray_13:
            '#333333',

        gray_14:
            '#666666',

        gray_15:
            '#767676',

        gray_16:
            '#8a8a8a',

        gray_17:
            '#878787',

        gray_18:
            '#231f20',

        gray_20:
            '#2f2f2a',

        backgroud_dark_theme:
            '#262626',

    };